/**
 * 화면 전환 애니메이션 (Fade-in)
 */
window.addEventListener('load', function () {
  document.body.classList.add('is-loaded');
});

// 만약 자바스크립트 오류 등으로 화면이 계속 안 보일 경우를 대비한 안전장치 (3초 후 강제 노출)
setTimeout(function () {
  if (!document.body.classList.contains('is-loaded')) {
    document.body.classList.add('is-loaded');
  }
}, 3000);
/* modlab 2026-10-11 v1.0.0: reopen header dropdown when hovered from below */
(function () {
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var t = e.target;
    if (!t || !t.closest) return;
    var link = t.closest('header-menu .menu-list__list-item > [ref="menuitem"]');
    if (!link) return;
    var li = link.parentElement, hm = link.closest('header-menu');
    if (!hm || typeof hm.activate !== 'function') return;
    if (!li.querySelector('[ref="submenu[]"]')) return;
    if (link.getAttribute('aria-expanded') === 'true') return;
    hm.activate({ target: li });
  }, { passive: true });
})();
